<template>
  <div class="box">
      <div class="ratelist" style="margin-bottom: 50px;">
        <div class="ratelist_text">
          | 汇率列表
        </div>
        <div class="ratelist_box">
          <el-table
           :data="tableData"
           style="width: 100%">
           <el-table-column
             prop="name"
             label=" "
             align="center"
             >
           </el-table-column>
           <el-table-column
             prop="cost"
             label="1 CAD"
             align="center"
             >
           </el-table-column>
           <el-table-column
             prop="date"
             label="操作"
             align="center"
             >
            <template slot-scope="scope">
              <el-button type="text" @click="showDia(scope.row)">编辑</el-button>
            </template>
           </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="discountsBox">
        <div class="discountsBox_text">
          | 优惠信息
        </div>
      <div>
        <el-input
                type="textarea"
                :autosize="{ minRows: 4}"
                placeholder="可输入优惠内容"
                v-model="textarea2"
                class="discountsBox_input"
                >
              </el-input>
      </div>
      <div style="width:100%;text-align: center;margin-top: 20px;">
        <el-button type="primary" @click="updateDisCount">
          提 交
        </el-button>
      </div>
      </div>
  <!-- 操作Dialog -->
  <el-dialog
    title="编辑汇率"
    :visible.sync="dialogVisible"
    width="30%"
    :modal-append-to-body='false'
    >
    <div class="dia">
      <span>1 </span>
      <span v-if="title">CNY </span>
      <span v-else-if="!title">USD </span>
      <span>= </span>
      <el-input class="dia_input" v-model="rate"></el-input>
      <span> CAD</span>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateRate">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  </div>
</template>

<script>
import * as charge from '../../api/charge'

export default {
  data(){
    return{
      index:['CNY','USD'],
      dialogVisible:false,
      title:true,
      textarea2:'',
      rateId:'',
      rate:'',
      rateList:[],
      tableData:[{
        name:'CNY',
        cost:0,
        id:0
      },
      {
        name:'USD',
        cost:0,
        id:0
      }
      ],
    }
  },
  created(){
    this.getRateList()
    this.getDiscount()
  },
  methods:{
    showDia(row){
      console.log(112,row);
     this.title=row.name=='CNY'?true:false
     this.rateId=row.id
     this.rate=row.cost
     this.dialogVisible=true
    },
    getRateList(){
      let param={}
      charge.getRateList(param).then(res =>{
        console.log(res);
        if(res.status!==200)
        return this.$message.error('获取汇率列表失败')
        if(res.data.code!==0)
        return this.$message.error('参数错误')
        this.rateList=res.data.data.list
        this.putRateToList()
      })
    },
    putRateToList(){
      for(var i=0;i<this.rateList.length;i++){
        if(this.tableData && this.tableData[i]){
          this.tableData[i].name=this.rateList[i].exchangeCurrenty
          this.tableData[i].cost=this.rateList[i].rate
          this.tableData[i].id=this.rateList[i].rateId
        }
      }
    },
    updateRate(){
      let param={
        rateId:this.rateId,
        rate:this.rate
      }
      charge.updateRate(param).then(res =>{
        if(res.status!==200)
        return this.$message.error('编辑汇率失败')
        if(res.data.code!==0)
        return this.$message.error(res.data.msg)
        this.getRateList()
        this.$message.success('编辑汇率成功')
        this.dialogVisible=false
      })
    },
    updateDisCount(){
      let param={
        discountId:1,
        title:this.textarea2
      }
      charge.updateDis(param).then(res =>{
        if(res.status!==200)
        return this.$message.error('编辑汇率失败'+res.msg)
        if(res.data.code!==0)
        return this.$message.error(res.data.msg)
        this.$message.success('编辑优惠信息成功')
      }).catch('error')
    },
    getDiscount(){
        let param={}
        charge.getDiscount(param).then(res =>{
        if(res.status!==200)
        return this.$message.error('获取优惠列表失败：'+res.msg)
        if(res.data.code!==0)
        return this.$message.error('获取优惠列表失败：'+res.data.msg)
        this.textarea2=res.data.data.title
        })
      }
  }
}
</script>

<style lang="less" scoped>
.box{
  position: relative;
  margin: 30px 50px 0 40px;
  .ratelist_text,.discountsBox_text{
    font-size: 20px;
    margin-bottom: 20px;
  }
}
.dia{
  text-align: center;
  .dia_input{
   width: 50%;
 }
}
</style>


// WEBPACK FOOTER //
// rate.vue?1c767996